import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const EssentialNeedsConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/essential-needs",
    component: React.lazy(() => import("./essential-needs")),
  },
];
